var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColumns = function SvgColumns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 16A1.75 1.75 0 0 0 7 14.25V1.75A1.75 1.75 0 0 0 5.25 0h-2.5A1.75 1.75 0 0 0 1 1.75v12.5c0 .966.784 1.75 1.75 1.75zm.25-1.75a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25V1.75a.25.25 0 0 1 .25-.25h2.5a.25.25 0 0 1 .25.25zM13.25 16A1.75 1.75 0 0 0 15 14.25V1.75A1.75 1.75 0 0 0 13.25 0h-2.5A1.75 1.75 0 0 0 9 1.75v12.5c0 .966.784 1.75 1.75 1.75zm.25-1.75a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25V1.75a.25.25 0 0 1 .25-.25h2.5a.25.25 0 0 1 .25.25z",
    clipRule: "evenodd"
  })));
};
export default SvgColumns;